<template>
  <div class="page">
    <Banner :top="0" />
    <div class="pc_ipad">
      <div class="layer1">
        <div class="left">
          <div class="row row1">
            <div>
              <img
                v-if="play1"
                class="play"
                src="~@/assets/spark-mini/play.png"
                alt=""
                @click="videoClick1"
              >
              <video
                ref="videoPlayer1"
                :autoplay="!_isMobile()"
                loop
                poster="~@/assets/spark-mini/row1.png"
                @click="videoClick1"
              >
                <source
                  src="https://pg-cn-assets2.oss-cn-hangzhou.aliyuncs.com/media/video%201.mp4"
                  type="video/mp4"
                >
              </video>
            </div>
            <div>
              <img
                src="~@/assets/spark-mini/row2.png"
              >
            </div>
          </div>
          <div class="row row1">
            <div>
              <img
                src="~@/assets/spark-mini/row3.png"
              >
            </div>
            <div>
              <img
                src="~@/assets/spark-mini/row4.png"
              >
            </div>
          </div>
          <div class="row row1">
            <div>
              <img
                src="~@/assets/spark-mini/row5.png"
              >
            </div>
            <div>
              <img
                v-if="play1"
                class="play"
                src="~@/assets/spark-mini/play.png"
                alt=""
                @click="videoClick3"
              >
              <video
                ref="videoPlayer3"
                autoplay
                loop
                poster="~@/assets/spark-mini/row6.png"
                @click="videoClick3"
              >
                <source
                  src="https://pg-cn-assets2.oss-cn-hangzhou.aliyuncs.com/media/%E6%AD%A3%E6%96%B9%E5%BD%A2-%E7%B6%B2%E6%A0%BC%E6%9B%BF%E6%8F%9B.mp4"
                  type="video/mp4"
                >
              </video>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="box">
            <img
              class="background"
              src="~@/assets/spark-mini/row-right.png"
            >
            <div class="right_btn_box">
              <img
                class="price"
                src="~@/assets/spark-mini/1699.png"
              >
              <img
                class="btn"
                src="~@/assets/spark-mini/button.png"
                @click="openTmallFun"
              >
              <img
                class="btn btn_jd"
                src="~@/assets/spark-mini/JD_button.png"
                @click="openJDFun"
              >

              <a
                :href="androidUrl"
                download=""
                style="cursor:pointer"
                @click="downloadAndroidFun"
              >
                <img
                  class="anzuo"
                  src="~@/assets/spark-mini/anzuo.png"
                  @click="downloadAndroidFun"
                >
                <!-- <p style="text-align:center;color:#fff;font-size:12px;">安卓版即将上线</p> -->
              </a>
              <img
                src="~@/assets/spark-mini/ios.png"
                @click="downIosFun"
              >
              <img
                class="text"
                src="~@/assets/spark-mini/text.png"
              >
            </div>
          </div>
        </div>
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-mini/sec 02.png">
      </div>
      <div class="layer3">
        <img src="~@/assets/spark-mini/sec 10.png">
      </div>
      <div class="layer4">
        <img src="~@/assets/spark-mini/sec 06.png">
      </div>
      <div class="layer5">
        <img src="~@/assets/spark-mini/sec 03.png">
      </div>
      <div class="layer6">
        <img src="~@/assets/spark-mini/sec 07.png">
      </div>
      <div class="layer7">
        <img src="~@/assets/spark-mini/sec 9.png">
      </div>
      <div class="layer8">
        <img src="~@/assets/spark-mini/sec 05.png">
      </div>
      <div class="layer9">
        <img src="~@/assets/spark-mini/end.png">
      </div>
    </div>
    <div class="mobile">
      <vue-carousel
        :data="slides"
        :slide-on-swipe="false"
        class="carousel"
      />
      <div class="layer2">
        <img
          src="~@/assets/spark-mini/mobile/row1.png"
        >
        <div class="right_btn_box">
          <img
            class="btn"
            src="~@/assets/spark-mini/button.png"
            @click="openTmallFun"
          >
          <img
            class="btn btn_jd"
            src="~@/assets/spark-mini/JD_button.png"
            @click="openJDFun"
          >
          <img
            class="anzuo"
            src="~@/assets/spark-mini/anzuo.png"
            @click="downloadAndroidFun"
          >
          <img
            class="ios"
            src="~@/assets/spark-mini/ios.png"
            @click="downIosFun"
          >
          <img
            class="text"
            src="~@/assets/spark-mini/text.png"
          >
        </div>
      </div>
      <div class="layer3">
        <img
          v-if="play2"
          class="play"
          src="~@/assets/spark-mini/play.png"
          @click="videoClick1"
        >
        <video
          ref="videoPlayer2"
          loop
          poster="~@/assets/spark-mini/mobile/row2.png"
          @click="videoClick2"
        >
          <source
            src="https://pg-cn-assets2.oss-cn-hangzhou.aliyuncs.com/media/video%201.mp4"
            type="video/mp4"
          >
        </video>
      </div>
      <div class="layer4">
        <img
          src="~@/assets/spark-mini/mobile/row3.png"
        >
      </div>
      <div class="layer5">
        <img
          src="~@/assets/spark-mini/mobile/row4.png"
        >
      </div>
      <div
        class="layer6"
        style="margin-top:35%"
      >
        <img
          src="~@/assets/spark-mini/mobile/row5.png"
        >
      </div>
      <div
        class="layer7"
      >
        <img
          src="~@/assets/spark-mini/mobile/row6.png"
        >
      </div>
      <div
        style="margin-top:5%"
        class="layer8"
      >
        <img
          src="~@/assets/spark-mini/mobile/row7.png"
        >
      </div>
      <div
        style="margin-top:5%"
        class="layer9"
      >
        <img
          src="~@/assets/spark-mini/mobile/row8.png"
        >
      </div>
      <div
        style="margin-top:5%"
        class="layer10"
      >
        <img
          src="~@/assets/spark-mini/mobile/row9.png"
        >
      </div>
      <div
        style="margin-top:30%"
        class="layer11"
      >
        <img
          src="~@/assets/spark-mini/mobile/row10.png"
        >
      </div>
      <div
        style="margin-top:30%"
        class="layer12"
      >
        <img
          src="~@/assets/spark-mini/mobile/row11.png"
        >
      </div>
    </div>
  </div>
</template>
<script>
import Banner from '@/components/banner'
import VueCarousel from '@chenfengyuan/vue-carousel'
import axios from 'axios'
import { NEW_API_URL } from '@/urls'
export default {
  components: {
    Banner,
    VueCarousel
  },
  data () {
    let row1 = require('@/assets/spark-mini/row1.png')
    let row2 = require('@/assets/spark-mini/row2.png')
    let row3 = require('@/assets/spark-mini/row3.png')
    let row4 = require('@/assets/spark-mini/row4.png')
    let row5 = require('@/assets/spark-mini/row5.png')
    let row6 = require('@/assets/spark-mini/row6.png')
    return {
      play1: false,
      play2: true,
      slides: [
        `<div> <img src="${row1}" > </div>`,
        `<div> <img src="${row2}" > </div>`,
        `<div> <img src="${row3}" > </div>`,
        `<div> <img src="${row4}" > </div>`,
        `<div> <img src="${row5}" > </div>`,
        `<div> <img src="${row6}" > </div>`
      ],
      androidUrl: '',
      num: 0
    }
  },
  watch: {},
  created () {
    this.downloadAndroidFun()
  },
  methods: {
    videoClick1 () {
      this.play1 = !this.$refs.videoPlayer1.paused

      this.$refs.videoPlayer1.paused === true
        ? this.$refs.videoPlayer1.play()
        : this.$refs.videoPlayer1.pause()
    },
    videoClick2 () {
      this.play2 = !this.$refs.videoPlayer2.paused
      this.$refs.videoPlayer2.paused === true
        ? this.$refs.videoPlayer2.play()
        : this.$refs.videoPlayer2.pause()
    },
    videoClick3 () {
      this.play1 = !this.$refs.videoPlayer3.paused

      this.$refs.videoPlayer3.paused === true
        ? this.$refs.videoPlayer3.play()
        : this.$refs.videoPlayer3.pause()
    },
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    openTmallFun () {
      if (this._isMobile()) {
        window.open('https://m.tb.cn/h.UolN1R4?tk=V8bndilcBEP')
      } else {
        window.open(
          'https://detail.tmall.com/item.htm?spm=a220m.1000858.1000725.41.98752449GB9acQ&id=672661094097&skuId=4843975697677&areaId=440100&user_id=2210522335310&cat_id=2&is_b=1&rn=3c2f8c84122dc941899c41bfad597e6d'
        )
      }
    },
    openJDFun () {
      if (this._isMobile()) {
        window.open('https://3.cn/25wtP-aX')
      } else {
        window.open(
          'https://item.jd.com/10050052698189.html'
        )
      }
    },
    //   download android
    async downloadAndroidFun () {
      this.num += 1
      try {
        await axios
          .get(`${NEW_API_URL}/api/package/spark`, {
            headers: {
              //   'Authorization': `JWT ${this.token || window.localStorage.getItem('PG_TOKEN')}`,
              'Content-Type': 'application/json;charset=UTF-8'
            }
          })
          .then((res) => {
            if (res.data.android) {
              let userAgent = navigator.userAgent.toLowerCase()
              if (
                userAgent.indexOf('android') > -1 &&
                                this.num > 1
              ) {
                window.open(res.data.android.download_url)
              } else {
                this.androidUrl = res.data.android.download_url
              }
            }
          })
          .catch((err) => {
            console.error('Fail!!', err)
          })
      } catch (err) {
        console.log(err, '请求出错！')
      }
    },
    // download ios
    downIosFun () {
      window.open('https://apps.apple.com/cn/app/id1516758668')
    }
  }
}
</script>
<style lang="scss" scoped>
.pc_ipad {
  display: block;
  padding-top: 54px;
}
.mobile {
  display: none;
}
.page {
  // padding-top: 5.5%;
  background: #fff;
  min-height: 100vh;

  .layer1 {
    display: flex;
    .left {
      flex: 1435;
      padding-right: 1%;
      .row {
        display: flex;
        width: 100%;
        box-sizing: border-box;
        margin-bottom: 10px;
        div:nth-child(1) {
          margin-right: 1%;
        }
        div {
          position: relative;
          flex: 1;
          max-width: 100%;
          img,
          video {
            width: 100%;
          }
          .play {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 20%;
          }
        }
      }
      .row:nth-child(3) {
        margin: 0;
      }
    }
    .right {
      flex: 486;
      background: red;
      box-sizing: border-box;
      padding-top: 8.4%;
      text-align: center;
      .box {
        margin: 0 auto;
        width: 80%;
        position: relative;
        .background {
          width: 100%;
        }
        .right_btn_box {
          height: 100%;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%, 0);
          padding-top: 200%;
          .price {
            margin-bottom: 10%;
          }
          .btn {
          }
          .btn_jd{
            margin-top:5%;
            margin-bottom: 120%;

          }
          .anzuo {
            margin-bottom: 10%;
          }
          .text {
            margin: 0 auto;
            margin-top: 8%;
            width: 50%;
          }
        }
      }
    }
  }
  .layer3 {
    margin-top: -25%;
  }

  @media (max-width: 768px) {
    .pc_ipad {
      display: none;
    }
    .mobile {
      min-height: 100%;
      padding-top: 44px;
      background: #fff;
      display: block;
      .carousel {
        height: 100%;
      }
      .layer2 {
        position: relative;
        text-align: center;
        .right_btn_box {
          width: 100%;
          position: absolute;
          top: 65%;

          .btn {
            margin: 0 auto;
            width: 56%;
          }
          .btn_jd{
            margin: 3% auto 0 auto;

          }
          .anzuo {
            margin: 5% auto 0 auto;
            width: 45%;
          }
          .ios {
            margin: 3% auto 0 auto;
            width: 45%;
          }
          .text {
            margin: 3% auto 0 auto;
            width: 25%;
          }
        }
      }
      .layer3 {
        margin-top: 0%;
        position: relative;
        .play {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 20%;
        }
      }
      // .layer4{
      //   img{
      //     width:100%;
      //   }
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/spark-mini.vue